import React from 'react';
import { FaInstagram } from 'react-icons/fa';
import WhatsAppIcon from './WhatsAppIcon';

const FloatingButtons = ({ instagramLink, onWhatsAppClick, isHidden = false }) => {
  return (
    <div
      className={`fixed bottom-6 right-6 flex flex-col space-y-4 z-40 transition-all duration-300 ${
        isHidden ? 'opacity-0 translate-y-3 pointer-events-none' : 'opacity-100 translate-y-0'
      }`}
    >
      <button
        onClick={onWhatsAppClick}
        className="w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform focus:outline-none"
        aria-label="Chat on WhatsApp"
      >
        <WhatsAppIcon className="w-8 h-8" />
      </button>
      <a
        href={instagramLink}
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 bg-pink-600 text-white rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform focus:outline-none"
        aria-label="Open Instagram"
      >
        <FaInstagram className="w-6 h-6" />
      </a>
    </div>
  );
};

export default FloatingButtons;
